import React, { Component } from "react";
import Select from "react-select";
import Swal from "sweetalert2";

const hiddenFileInput = React.createRef(null);

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class MoveForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>Movimiento de producto</legend>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Establecimiento que envía:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_movimiento
                      ? this.props.state.bitacora_movimiento.establecimiento_envia_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="container"> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Establecimiento que recibe:</label>
                  <div className="form-control">
                    {this.props.state.bitacora_movimiento
                      ? this.props.state.bitacora_movimiento.establecimiento_recibe_nombre.toUpperCase()
                      : null}
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="producto">
                    Producto: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="producto"
                    name="producto"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={false}
                    onChange={this.props.handleProductChange}
                    theme="neutral40"
                    value={
                      this.props.state.producto !== null ||
                      this.props.state.producto !== ""
                        ? this.props.state.producto
                        : { label: "Seleccione", key: "0" }
                    }
                    options={this.props.state.cat_productos}
                    getOptionLabel={(producto) =>
                      producto.no_registro
                        ? `${producto.nombre_comercial} (${producto.no_registro})`
                        : `${producto.nombre_comercial}`
                    }
                    getOptionValue={(producto) => producto.id}
                    noOptionsMessage={() => "No se encontraron productos"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="producto-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="presentacion">
                    Presentación: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="presentacion"
                    name="presentacion"
                    isMulti={false}
                    isClearable={false}
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={this.props.handlePresentationChange}
                    value={
                      this.props.state.presentacion !== null ||
                      this.props.state.presentacion !== ""
                        ? this.props.state.presentacion
                        : { label: "Seleccione", key: "0" }
                    }
                    theme="neutral40"
                    options={this.props.state.cat_presentacion}
                    getOptionLabel={(presentacion) => {
                      return !presentacion.empaque
                        ? `${presentacion.cantidad} ${presentacion.unidad_medida}`
                        : `${presentacion.empaque.toUpperCase()} (${
                            presentacion.cantidad
                          }${presentacion.unidad_medida})`;
                    }}
                    getOptionValue={(presentacion) => presentacion.id}
                    noOptionsMessage={() => "No se encontraron presentaciones"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="presentacion-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="fabricante">Fabricante:</label>
                  <div
                    className="form-control"
                    name="fabricante"
                    id="fabricante"
                  >
                    {this.props.state.fabricante
                      ? this.props.state.fabricante.razon_social
                      : null}
                  </div>
                </div>
                <div
                  className="invalid-feedback"
                  style={{ display: "none" }}
                  id="fabricante-error"
                ></div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div
                className={
                  this.props.state.producto_valido ? "col-lg-6" : "col-lg-10"
                }
              >
                <div className="form-group">
                  <label htmlFor="lote">
                    Lote: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    onChange={this.props.handleCantidadLote}
                    name="lote"
                    value={this.props.state.cantidad_lote.lote}
                    className="form-control"
                    id="lote"
                    placeholder="Ingrese lote"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="lote-error"
                  ></div>
                </div>
              </div>

              {this.props.state.producto_valido ? (
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="cantidad">
                      Cantidad: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      onChange={this.props.handleCantidadLote}
                      name="cantidad"
                      value={this.props.state.cantidad_lote.cantidad}
                      className="form-control"
                      id="cantidad"
                      placeholder="Ingrese cantidad"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="cantidad-error"
                    ></div>
                  </div>
                </div>
              ) : null}

              <div className="col-lg-2" style={{ marginTop: "1.5em" }}>
                <div className="form-group">
                  {this.props.state.producto_valido ? (
                    <button
                      type="button"
                      title="Añadir cantidad y lote"
                      className="btn bg-gradient-blue btn-block"
                      onClick={this.props.addCantidadLote}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  ) : (
                    <button
                      type="button"
                      title="Verificar producto"
                      className="btn bg-gradient-yellow btn-block"
                      onClick={this.props.verifyProduct}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped mb-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center" width="25%">
                          Lote
                        </th>
                        <th className="text-center" width="20%">
                          Cantidad
                        </th>
                        <th className="text-center" width="20%">
                          Fecha fabricación
                        </th>
                        <th className="text-center" width="20%">
                          Vencimiento
                        </th>
                        <th className="text-center" width="10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.state.cantidades_lotes.length > 0 ? (
                        this.props.state.cantidades_lotes.map((obj, index) => (
                          <tr key={index} id={"o" + index}>
                            <td className="text-center">{obj.lote}</td>
                            <td className="text-center">{obj.cantidad}</td>
                            <td className="text-center">
                              {obj.fecha_fabricacion}
                            </td>
                            <td className="text-center">
                              {obj.vencimiento_lote}
                            </td>
                            <td className="text-center">
                              <button
                                title="Remover"
                                id={index}
                                onClick={this.props.removeCantidadLote}
                                className="btn btn-warning d-block ml-4"
                              >
                                <i id={index} className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Sin cantidades ni lotes a mostrar
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <hr />

            {["3", "9", "10", "16"].includes(
              this.props.state.bitacora_movimiento.actividad_recibe_id
            ) ? (
              <>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label htmlFor="num_factura">
                        Número de factura:{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={this.props.state.num_factura}
                        onChange={this.props.handleNumFacturaChange}
                        id="num_factura"
                        placeholder="Ingrese número de factura"
                        name="num_factura"
                        className="form-control"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="num_factura-error"
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-10">
                    <div className="form-group">
                      <label htmlFor="tipo_documento">
                        Documentos: <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="tipo_documento"
                        id="tipo_documento"
                        onChange={this.props.handleChangeTipoDocumento}
                        value={this.props.state.tipo_documento_id}
                        className="form-control"
                      >
                        <option value="">Seleccione tipo de documento</option>
                        {this.props.state.tipo_documentos.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="tipo_documento-error"
                      ></div>
                      <div className="text-warning" id="t_d-error">
                        <small>Solo se aceptan archivos ".pdf"*</small>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2" style={{ marginTop: "1.5em" }}>
                    <div className="form-group">
                      <button
                        type="button"
                        name="b_documento"
                        className="btn btn-primary btn-block"
                        onClick={(e) => {
                          if (this.props.state.tipo_documentos.length === 0) {
                            Swal.fire({
                              icon: "warning",
                              title: "¡Atención!",
                              text: "Ya cuenta con los documentos requeridos.",
                              confirmButtonText: "Regresar",
                            });
                            return;
                          }

                          if (this.props.state.tipo_documento_id === "") {
                            Swal.fire({
                              icon: "warning",
                              title: "¡Atención!",
                              text: "Seleccione el tipo de documento a cargar.",
                              confirmButtonText: "Regresar",
                            });
                            return;
                          } else {
                            hiddenFileInput.current.click();
                          }
                        }}
                      >
                        Seleccionar archivo
                      </button>
                      <input
                        type="file"
                        accept=".pdf"
                        ref={hiddenFileInput}
                        name="documento"
                        onChange={this.props.handleFile}
                        onClick={(e) => {
                          //this.props.component.validarseleccion(event);
                          e.target.value = null;
                        }}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th className="text-center" width="30%">
                              Tipo documento
                            </th>
                            <th className="text-center" width="30%">
                              Nombre documento
                            </th>
                            <th className="text-center" width="30%">
                              Vista previa
                            </th>
                            <th className="text-center" width="10%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.documentos.length > 0 ? (
                            this.props.state.documentos.map((doc, index) => (
                              <tr key={index} id={index}>
                                <td className="text-center">
                                  {doc.tipo_documento}
                                </td>
                                <td className="text-center">{doc.nombre}</td>
                                <td className="text-center">
                                  <div
                                    onClick={this.props.handleVistaPrevia}
                                    data-file={doc.pdf}
                                    name="pdf"
                                    className="btn btn-danger"
                                    id={index}
                                    width="60"
                                    title="Vista previa"
                                  >
                                    <i
                                      className="fa fa-file-pdf"
                                      name="pdf"
                                      id={index}
                                    ></i>
                                  </div>
                                </td>
                                <td className="text-center">
                                  <div
                                    className="btn btn-warning remover-documento"
                                    id={index}
                                    title="Remover"
                                    data-tipo_documento_id={
                                      doc.tipo_documento_id
                                    }
                                    data-descripcion={doc.tipo_documento}
                                    onClick={this.props.removeDocumento}
                                  >
                                    <i
                                      className="fas fa-trash"
                                      id={index}
                                      title="Remover"
                                      data-tipo_documento_id={
                                        doc.tipo_documento_id
                                      }
                                      data-descripcion={doc.tipo_documento}
                                      onClick={this.props.removeDocumento}
                                    ></i>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No hay documentos
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <hr />

            <button type="submit" className="btn bg-gradient-green btn-block text-white">
              Generar
            </button>

            {/* </div> */}
          </fieldset>

          <div className={this.props.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              src={`data:application/pdf;base64,${this.props.state.previa_url}`}
              width="100%"
              height="100%"
              name="iframe"
            ></iframe>
            <center>
              <div className="btn-group">
                <div
                  onClick={this.props.handleCloseVistaPrevia}
                  className="btn btn-danger"
                >
                  Regresar
                </div>
              </div>
            </center>
          </div>
        </div>
      </>
    );
  }
}

export default MoveForm;
